module.exports = __webpack_public_path__ + "static/media/logo-magento.52f388a9.png";